import { CoreEnvironment } from '@lx/shared/types';
import { getApplicationInitializationProviders } from './get-application-initializers-providers.function';
import { getCoreProviders } from './get-core-providers.function';
import { getErrorHandlerProviders } from './get-error-handler-providers.function';
import { APPLICATION_CONFIGURATION_SERVICE, ApplicationConfigurationService } from '@lx/shared/app-config';

export const getApplicationProviders = (env: CoreEnvironment) => [
  { provide: APPLICATION_CONFIGURATION_SERVICE, useClass: ApplicationConfigurationService },
  ...getApplicationInitializationProviders(env),
  ...getCoreProviders(env),
  ...getErrorHandlerProviders(),
];
